import { tWithKeyAttr as t } from "../i18nHelper";
import { IPrescription, ITherapistDocument } from "../types/types";

export interface IServerStatus {
  id: number;
  desc: string;
}
export interface IStatus {
  Id: number;
  text: string;
  class: string;
}

export const statuses: IStatus[] = [
  {
    Id: 4,
    text: t("STATUS_DONE"),
    class: "done",
  },
  {
    Id: 3,
    text: t("STATUS_IN_PROGRESS"),
    class: "inProgress",
  },
  {
    Id: 2,
    text: t("STATUS_STUCK"),
    class: "stuck",
  },
  {
    Id: 1,
    text: t("STATUS_NOT_YET_ADDRESSED"),
    class: "notYetAddressed",
  },
  {
    Id: 0,
    text: t("PROFILE_NO_INFO"),
    class: "notYetAddressed",
  },
];

export const serverStatusesDefault: IServerStatus[] = [
  {
    id: 1,
    desc: t("SERVER_STATUS_WAITING"),
  },
  {
    id: 2,
    desc: t("SERVER_STATUS_IN_PROGRESS"),
  },
  {
    id: 3,
    desc: t("SERVER_STATUS_DONE"),
  },
];

export const getStatusClass = (id: number): string => {
  return id === 3 ? "done" : id === 2 ? "inProgress" : "notYetAddressed";
};
export const getStatusText = (id: number): string => {
  const status = statuses.find((s) => s.Id === id);
  return status ? status.text : "";
};
export const getServerStatusText = (
  id: number,
  statuses: IServerStatus[]
): string => {
  
  if (id === 3) return t("SERVER_STATUS_DONE");
  if (id === 2) return t("SERVER_STATUS_IN_PROGRESS");
  return t("SERVER_STATUS_WAITING");
};

export const therapistDocuments: ITherapistDocument[] = [
  {
    id: "#41566",
    issued: new Date("November 20, 2023 13:15:00"),
    status: "done",
    urgent: true,
    userId: "#25648",
    category: t('GENERAL'),
  },
  {
    id: "#86434",
    issued: new Date("November 21, 2023 13:15:00"),
    status: "inProgress",
    urgent: false,
    userId: "#25648",
    category: t('GENERAL'),
  },
  {
    id: "#90753",
    issued: new Date("November 30, 2023 13:15:00"),
    status: "done",
    urgent: false,
    userId: "#25648",
    category: t('GENERAL'),
  },
  {
    id: "#27809",
    issued: new Date("December 10, 2023 13:15:00"),
    status: "stuck",
    urgent: false,
    userId: "#25648",
    category: t('GENERAL'),
  },
  {
    id: "#78903",
    issued: new Date("December 14, 2023 13:15:00"),
    status: "stuck",
    urgent: false,
    userId: "#25648",
    category: t('GENERAL'),
  },
  {
    id: "#78905",
    issued: new Date(new Date().setDate(new Date().getDate() - 1)),
    status: "notYetAddressed",
    urgent: true,
    userId: "#25646",
    category: t('GENERAL'),
  },
  {
    id: "#78908",
    issued: new Date(),
    status: "notYetAddressed",
    urgent: false,
    userId: "#25649",
    category: t('GENERAL'),
  },
  {
    id: "#79907",
    issued: new Date(),
    status: "notYetAddressed",
    urgent: false,
    userId: "#25649",
    category: t('GENERAL'),
  },
];
export const prescriptionsExample: IPrescription[] = [
  {
    id: "6532512",
    medicine: "Nocturno",
    doze: "3.75 mg",
    instructions: t('SWALLOW_1_TABLET_ONCE_DAILY'),
    issued: new Date(Date.now() - 86400000), //yesterday
    userId: "1",
    exp: new Date(Date.now() + 86400000 * 10),
    status: "notYetAddressed",
    urgent: false,
    category: t('GENERAL'),
  },
  {
    id: "6532512",
    medicine: "Nocturno",
    doze: "3.75 mg",
    instructions: t('SWALLOW_1_TABLET_ONCE_DAILY'),
    issued: new Date("May 2, 2023 12:00:00"),
    userId: "1",
    exp: new Date("July 2, 2023 12:00:00"),
    status: "notYetAddressed",
    urgent: false,
    category: t('GENERAL'),
  },
  {
    id: "6532598",
    medicine: "Xanax",
    doze: "250 mcg",
    instructions: t('SWALLOW_1_TABLET_ONCE_DAILY'),
    issued: new Date("May 2, 2023 12:00:00"),
    userId: "1",
    exp: new Date("May 2, 2024 12:00:00"),
    status: "notYetAddressed",
    urgent: false,
    category: t('GENERAL'),
  },
];
